import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TasksSvg } from '../../../Images/ComonSvgs';

const UrlBar = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const handleClick = (url) => {
        navigate(url)
    }
    return (
        <>
            <ol className="breadcrumb">
                <li className="breadcrumb-item" onClick={() => handleClick('/auth/dashboard')}><TasksSvg /></li>
                <li className="breadcrumb-item active" onClick={() => handleClick('/auth/tasks')} >Tasks</li>
                
            </ol>
        </>
    )

}
export default UrlBar